/**
 * Drives a modal's open/closed state off a single URL query param.
 * Opening pushes a history entry (so back closes it); closing replaces
 * the current entry so the param disappears without adding history noise.
 */
export function useQueryModal(param: string) {
  const route = useRoute()
  const router = useRouter()

  const activeId = computed(() => {
    const v = route.query[param]
    return typeof v === 'string' && v ? v : null
  })

  function open(id: number | string) {
    router.push({ query: { ...route.query, [param]: String(id) } })
  }

  function close() {
    if (!(param in route.query)) return
    const query = { ...route.query }
    delete query[param]
    router.replace({ query })
  }

  return { activeId, open, close }
}
